import React, { useEffect } from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import { useLocation } from "react-router-dom";

function About() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Navbar />
      <div className="">
        <div className="container">
          <div className="px-md-5">
            <div className="card bg-light">
              <div
                className="h4 text-center"
                style={{
                  backgroundColor: "#66a725",
                  color: "#fff",
                  padding: 4,
                  borderTopLeftRadius: "0.375rem",
                  borderTopRightRadius: "0.375rem",
                }}
              >
                About us
              </div>
              <div className="p-4">
                <div>
                  <h3 className="mt-4" style={{ fontWeight: "400" }}>
                    Welcome to Ontap Technologies, the company behind{" "}
                    <strong>Salarytap</strong> — where we believe financial
                    freedom should be immediate, not tied to payday.
                  </h3>

                  <h6 className="mt-3" style={{ fontWeight: "400" }}>
                    Founded by Yuv Khosla and Vineet Pandey, Ontap Technologies
                    blends decades of experience in financial services and
                    technology with one bold vision: to transform how employees
                    experience their earnings and how companies care for their
                    workforce.
                  </h6>

                  <h6 className="mt-3" style={{ fontWeight: "400" }}>
                    Yuv Khosla, co-founder, also serves as Chief Operating
                    Officer of Capital Trust Limited, a listed NBFC with a
                    long-standing reputation in the Indian financial sector.
                    Backed by this deep institutional knowledge, Salarytap
                    delivers robust, compliant, and scalable solutions that help
                    employers empower their teams and help employees take
                    control of their finances.
                  </h6>

                  <hr className="my-4" />

                  <h4
                    className="mt-3"
                    style={{ fontSize: "18px", fontWeight: "600" }}
                  >
                    Our Mission
                  </h4>
                  <h6 className="mt-3" style={{ fontWeight: "400" }}>
                    We are here to redefine the paycheck — making it flexible,
                    accessible, and on-demand.
                  </h6>
                  <h6 className="mt-3" style={{ fontWeight: "400" }}>
                    By giving employees instant access to the salary they’ve
                    already earned, Salarytap reduces financial stress,
                    strengthens workplace morale, and boosts productivity — all
                    at zero cost or credit risk to the employer.
                  </h6>
                  <h6 className="mt-3" style={{ fontWeight: "400" }}>
                    We are committed to delivering innovative, transparent, and
                    easy-to-use financial solutions that make a real difference
                    in people’s lives.
                  </h6>

                  <hr className="my-4" />

                  <h4
                    className="mt-3"
                    style={{ fontSize: "18px", fontWeight: "600" }}
                  >
                    Message from the Founders
                  </h4>
                  <h6
                    className="mt-3"
                    style={{ fontWeight: "400", fontStyle: "italic" }}
                  >
                    “At Ontap Technologies, we believe financial empowerment
                    should belong to everyone.
                  </h6>
                  <h6
                    className="mt-2"
                    style={{ fontWeight: "400", fontStyle: "italic" }}
                  >
                    We set out to break the paycheck-to-paycheck cycle by giving
                    employees control over their earnings and giving employers a
                    way to offer meaningful, zero-cost financial wellness
                    benefits.
                  </h6>
                  <h6
                    className="mt-2"
                    style={{ fontWeight: "400", fontStyle: "italic" }}
                  >
                    With years of experience behind us, we understand the
                    challenges companies and individuals face — and we’re here
                    to offer smart, simple solutions that deliver lasting
                    impact.
                  </h6>
                  <h6
                    className="mt-2"
                    style={{ fontWeight: "400", fontStyle: "italic" }}
                  >
                    Join us as we reshape the future of pay.”
                  </h6>
                  <h6 className="mt-1" style={{ fontWeight: "500" }}>
                    — Yuv Khosla & Vineet Pandey, Co-founders, Ontap
                    Technologies
                  </h6>

                  <hr className="my-4" />

                  <h4
                    className="mt-3"
                    style={{ fontSize: "18px", fontWeight: "600" }}
                  >
                    Our Tagline
                  </h4>
                  <h6 className="mt-2" style={{ fontWeight: "500" }}>
                    <em>Because it is already yours</em>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
